import { global } from '#blokkli-build/chunk-global.js'

export const chunks = {
  global,
  rare: () => import('#blokkli-build/chunk-rare.js').then(v => v['rare'])
}

export const chunkMapping = {
  'block:accordeon': 'global',
  'block:blokkli_fragment': 'global',
  'block:button': 'global',
  'block:carousel': 'global',
  'block:contact': 'global',
  'block:from_library': 'global',
  'block:gallery': 'global',
  'block:icon_text_item': 'global',
  'block:icon_text_list': 'global',
  'block:iframe': 'global',
  'block:iframe_jobs': 'global',
  'block:image': 'global',
  'block:info_box': 'global',
  'block:link': 'global',
  'block:link_list': 'global',
  'block:newsletter': 'global',
  'block:quote': 'global',
  'block:search': 'global',
  'block:teaser': 'global',
  'block:teaser_list': 'global',
  'block:text': 'global',
  'block:text_image': 'global',
  'block:title': 'global',
  'block:video': 'global',
  'block:webform': 'rare',
  'fragment:Test': 'global'
}